// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';
import { socialProof } from './custom/social-proof.js';

$(document).ready(function () {
  offer.getState(function (data) {
    if (data.query.cmp === 'false') {
      $('.cmp-hide').hide();
      $('.cmp-show').show();
      $('.cmp-text1').html('and some');
      $('body').addClass('cmp-clear');
    }

    $('.prod-price').html(offer.getCurrency() + data.products[0].price);

    const iso_code = offer.getCountryIsoCode();
    socialProof(iso_code);
    if (iso_code === 'BE') {
      iso('DE LA BE', '/static/common/shared/country-flags/flag-be.svg', '/static/common/shared/made-for-be.svg', '0');
    } else if (iso_code === 'LU') {
      iso('DU LU', '/static/common/shared/country-flags/flag-lu.svg', '/static/common/shared/made-for-lu.svg', '0');
    } else if (iso_code === 'CH') {
      iso('DE LA CH', '/static/common/shared/country-flags/flag-ch.svg', '/static/common/shared/made-for-ch.svg', '0');
    } else {
      iso('DE LA FR ', '/static/common/shared/country-flags/flag-fr.svg', '/static/common/shared/made-for-fr.svg');
    }
    function iso(text1, flag, lbl, opacity) {
      $('.dynamicCount1').html(text1);
      $('.dynamicFlag').attr('src', flag);
      $('.garante-lbl').attr('src', lbl);
      $('.logo-land').css('opacity', opacity);
    }
  });

  const menu = $('#header .right-side');
  const opener = $('.nav-toggle');
  opener.click(function () {
    if (!menu.hasClass('opened')) {
      menu.addClass('opened');
    } else {
      menu.removeClass('opened');
    }
    $(this).next('.dropdown').slideToggle(300);
    $('.overlay').toggleClass('show');
  });

  function closeMenu() {
    $('.dropdown').slideUp(300);
    menu.removeClass('opened');
    $('.overlay').removeClass('show');
  }

  $('.menu-item').on('click', function (e) {
    closeMenu();
    let id = $(this).attr('data-name');
    const $target = $(id);

    if ($target.length > 0) {
      e.preventDefault();

      $('html, body').animate(
        {
          scrollTop: $target.offset().top,
        },
        {
          duration: 1000,
          step: (now, fx) => {
            let realPos = $target.offset().top;
            if (fx.end !== realPos) {
              fx.end = realPos;
            }
          },
        }
      );
    }
  });
});
